import { useParams } from 'react-router-dom';
import { useQuery, useQueryClient } from '@tanstack/react-query';

import useAxios from '../hooks/useAxios';
import { EQueryKeys } from '../constants/enums';
import { Subscription } from '../common/contracts';

import { EApiRoutes, fetchConfig, getApiRouteOrMock } from './api.utils';

interface SubscriptionsFilters {
  pageSize: number;
  status?: string;
}

const DEFAULT_SUBSCRIPTIONS_FILTERS: SubscriptionsFilters = {
  pageSize: 10,
  status: ''
};

export default function useSubscriptions(
  filters: SubscriptionsFilters = DEFAULT_SUBSCRIPTIONS_FILTERS
) {
  const axios = useAxios();
  const queryClient = useQueryClient();
  const { publisherId } = useParams();

  const getSubscriptions = useQuery<Subscription[]>({
    ...fetchConfig.general,
    queryKey: [EQueryKeys.SUBSCRIPTIONS, publisherId, filters],
    queryFn: async () => {
      const subscriptions = await axios.get(
        `${getApiRouteOrMock(EApiRoutes.SUBSCRIPTIONS)}?${buildQueryParams(filters)}`,
        {},
        publisherId ? { 'x-publishers': publisherId } : undefined
      );
      return subscriptions;
    },
    enabled: !!publisherId
  });

  return {
    getSubscriptions
  };
}

function buildQueryParams(filters: SubscriptionsFilters): string {
  const params = new URLSearchParams();

  Object.entries(filters).forEach(([key, value]) => {
    if (value !== undefined && value !== null && value !== '') {
      params.append(key, String(value));
    }
  });

  return params.toString();
}
